const ROUTER = {
  HOMEPAGE: '/',
  LOGIN: '/login',
  PRODUCT_DETAIL: '/product-detail',
  PAYMENT: '/payment',
  CART: '/cart',
  CENTER_SUPPORT: '/center-support',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  FAQ: '/faqs',
  DOCUMENTS: '/documents',
  WARRANTY_POLICY: '/warranty-policy',
  SALES_POLICY: '/sales-policy',
  PRIVACY_POLICY: '/privacy-policy',
  WEB_APP_TERMS_OF_USE: '/web-app-terms-of-use',
  ACCOUNT: '/account',
  PROJECTS: '/projects',
  ROOMS: '/rooms',
  ADDRESS: '/address',
  ORDER: '/orders',
  CHANGE_PASSWORD: '/change-password',
  DESIGN: '/design',
  FORGOT_PASSWORD: '/quen-mat-khau',
  RESET_PASSWORD: '/reset-password',
  ACTIVE_ACCOUNT: '/activate-account',
  CONFIRMED_DELETE: '/confirmed_delete',
  CONFIRMED_CHANGE_EMAIL: '/confirm_change_email',
  LINK_EXPIRED: '/link-expired',
  ABOUT_US: '/about-us',
  NOT_FOUND: '/not-found',
  CMS: '/cms',
  PRODUCT: '/products',
  CATEGORY: '/category',
  CUSTOMER: '/customers',
  DESIGN_CUSTOMER: '/design-customers',
  QUOTATION: '/quotation',
  PRODUCT_INVENTORY: '/product-inventory',
  PRODUCT_UNINVENTORY: '/product-uninventory',
  CREATE_PRODUCT_INVENTORY: '/create-product-inventory',
  UPDATE_PRODUCT_INVENTORY: '/update-product-inventory',
};

export default ROUTER;
